(function (window, document) {
  'use strict';

  // OpenAI Ads Measurement Pixel: KiaNEDy1zUCTEo2LitaJxJ

  if (window.__openAIAdsConversionsInstalled) return;
  window.__openAIAdsConversionsInstalled = true;

  var config = window.OpenAIAdsConfig;
  if (!config || !config.pixelId || typeof window.oaiq !== 'function') return;

  var consentResolved = false;
  var measurementAllowed = false;
  var personalizationOptOut = false;
  var pageEventsSent = false;
  var checkoutMeasured = false;
  var pendingMeasurements = [];
  var nativeFetch = typeof window.fetch === 'function' ? window.fetch : null;
  var cartState = normalizeCart(config.cart);
  var pendingLead = readPendingLead();

  function safeSessionGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeSessionSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {}
  }

  function safeSessionRemove(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {}
  }

  function integer(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? Math.max(0, Math.round(number)) : fallback;
  }

  function currency(value) {
    var code = String(value || config.currency || '').toUpperCase();
    return /^[A-Z]{3}$/.test(code) ? code : '';
  }

  function eventId(prefix) {
    var suffix;
    try {
      suffix = window.crypto && typeof window.crypto.randomUUID === 'function'
        ? window.crypto.randomUUID()
        : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    } catch (error) {
      suffix = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    }
    return prefix + '-' + suffix;
  }

  function contentItem(item, quantityOverride) {
    if (!item) return null;

    var id = item.id || item.variant_id || item.key;
    var name = item.name || item.product_title || item.title;
    var itemCurrency = currency(item.currency);
    var itemAmount = integer(
      item.amount !== undefined ? item.amount : (item.final_price !== undefined ? item.final_price : item.price),
      null
    );
    var itemQuantity = integer(quantityOverride !== undefined ? quantityOverride : item.quantity, null);
    var result = {content_type: String(item.content_type || 'product')};

    if (id !== undefined && id !== null && String(id)) result.id = String(id);
    if (name) result.name = String(name);
    if (itemQuantity !== null && itemQuantity > 0) result.quantity = itemQuantity;
    if (itemAmount !== null && itemCurrency) {
      result.amount = itemAmount;
      result.currency = itemCurrency;
    }

    return result;
  }

  function contentsData(items, totalAmount, totalCurrency) {
    var data = {type: 'contents'};
    var normalized = (items || []).map(function (item) {
      return contentItem(item);
    }).filter(Boolean);
    var amount = integer(totalAmount, null);
    var code = currency(totalCurrency);

    if (amount !== null && code) {
      data.amount = amount;
      data.currency = code;
    }
    if (normalized.length) data.contents = normalized;

    return data;
  }

  function measurementOptions(id) {
    var options = {};
    if (id) options.event_id = String(id);
    if (personalizationOptOut) options.opt_out = true;
    return Object.keys(options).length ? options : null;
  }

  function dispatchMeasurement(name, data, id, onSent) {
    try {
      var options = measurementOptions(id);
      if (options) {
        window.oaiq('measure', name, data, options);
      } else {
        window.oaiq('measure', name, data);
      }
      if (typeof onSent === 'function') onSent();
    } catch (error) {}
  }

  function measure(name, data, id, onSent) {
    if (!consentResolved) {
      pendingMeasurements.push({name: name, data: data, id: id, onSent: onSent});
      return;
    }
    if (!measurementAllowed) return;
    dispatchMeasurement(name, data, id, onSent);
  }

  function flushPendingMeasurements() {
    var queued = pendingMeasurements.slice();
    pendingMeasurements.length = 0;
    queued.forEach(function (event) {
      dispatchMeasurement(event.name, event.data, event.id, event.onSent);
    });
  }

  function sendPageEvents() {
    if (pageEventsSent || !measurementAllowed) return;
    pageEventsSent = true;

    measure('page_viewed', contentsData([config.page]), null);

    if (config.product && config.product.id) {
      measure(
        'contents_viewed',
        contentsData([config.product], config.product.amount, config.product.currency),
        null
      );
    }
  }

  function leadSuccessIsVisible() {
    return Boolean(
      document.querySelector('.kz-contact__success') ||
      document.querySelector('[data-kz-native-success]') ||
      document.querySelector('.section-contact-form .form-success')
    );
  }

  function readPendingLead() {
    var raw = safeSessionGet('openai_ads_pending_lead');
    if (!raw) return null;
    try {
      var value = JSON.parse(raw);
      if (!value || !value.id || value.path !== window.location.pathname || value.expiresAt < Date.now()) {
        safeSessionRemove('openai_ads_pending_lead');
        return null;
      }
      return value;
    } catch (error) {
      safeSessionRemove('openai_ads_pending_lead');
      return null;
    }
  }

  function sendSuccessfulLead() {
    if (!measurementAllowed || !pendingLead || !leadSuccessIsVisible()) return;

    measure('lead_created', {type: 'customer_action'}, pendingLead.id, function () {
      safeSessionRemove('openai_ads_pending_lead');
      pendingLead = null;
    });
  }

  function applyConsent(allowed, optOut) {
    consentResolved = true;
    measurementAllowed = Boolean(allowed);
    personalizationOptOut = Boolean(optOut);

    try {
      window.oaiq('consent', measurementAllowed);
    } catch (error) {}

    if (!measurementAllowed) {
      pendingMeasurements.length = 0;
      return;
    }

    sendPageEvents();
    sendSuccessfulLead();
    flushPendingMeasurements();
  }

  function readShopifyConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) {
      applyConsent(true, false);
      return;
    }

    try {
      var analyticsAllowed = typeof privacy.analyticsProcessingAllowed === 'function'
        ? privacy.analyticsProcessingAllowed()
        : privacy.userCanBeTracked();
      var marketingAllowed = typeof privacy.marketingAllowed === 'function'
        ? privacy.marketingAllowed()
        : privacy.userCanBeTracked();
      var saleAllowed = typeof privacy.saleOfDataAllowed === 'function'
        ? privacy.saleOfDataAllowed()
        : (typeof privacy.userDataCanBeSold === 'function' ? privacy.userDataCanBeSold() : true);

      applyConsent(analyticsAllowed && marketingAllowed, saleAllowed === false);
    } catch (error) {
      applyConsent(false, true);
    }
  }

  function initializeConsent() {
    document.addEventListener('visitorConsentCollected', readShopifyConsent);
    document.addEventListener('trackingConsentAccepted', readShopifyConsent);

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures(
          [{name: 'consent-tracking-api', version: '0.1'}],
          function (error) {
            if (error) {
              applyConsent(false, true);
              return;
            }
            readShopifyConsent();
          }
        );
        return;
      } catch (error) {
        applyConsent(false, true);
        return;
      }
    }

    readShopifyConsent();
  }

  function normalizeCart(cart) {
    var source = cart || {};
    return {
      amount: integer(source.amount !== undefined ? source.amount : source.total_price, null),
      currency: currency(source.currency),
      contents: (source.contents || source.items || []).map(function (item) {
        return {
          key: item.key ? String(item.key) : '',
          id: String(item.id || item.variant_id || item.key || ''),
          name: String(item.name || item.product_title || item.title || ''),
          content_type: String(item.content_type || 'product'),
          quantity: integer(item.quantity, 0),
          amount: integer(
            item.amount !== undefined ? item.amount : (item.final_price !== undefined ? item.final_price : item.price),
            null
          ),
          currency: currency(item.currency || source.currency)
        };
      }).filter(function (item) {
        return item.id && item.quantity > 0;
      })
    };
  }

  function requestUrl(input) {
    try {
      var raw = typeof input === 'string' ? input : input.url;
      return new URL(raw, window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function requestBody(init) {
    var body = init && init.body;
    if (!body) return {};

    try {
      if (typeof window.FormData !== 'undefined' && body instanceof window.FormData) {
        return {
          quantity: integer(body.get('quantity'), 1),
          id: body.get('id')
        };
      }
      if (typeof window.URLSearchParams !== 'undefined' && body instanceof window.URLSearchParams) {
        return {
          quantity: integer(body.get('quantity'), 1),
          id: body.get('id')
        };
      }
      if (typeof body === 'string') return JSON.parse(body);
    } catch (error) {}

    return {};
  }

  function cartRequest(input, init) {
    var url = requestUrl(input);
    if (!url || url.origin !== window.location.origin) return null;

    if (/\/cart\/add(?:\.js)?\/?$/.test(url.pathname)) {
      return {type: 'add', body: requestBody(init)};
    }
    if (/\/cart\/(?:change|update)(?:\.js)?\/?$/.test(url.pathname)) {
      return {type: 'change', body: requestBody(init)};
    }
    return null;
  }

  function addedItemsFromResponse(response, request) {
    var items = Array.isArray(response.items) ? response.items : [response];
    return items.map(function (item) {
      var requestedQuantity = request.body && request.body.quantity;
      var quantity = integer(requestedQuantity, integer(item.quantity, 1));
      var normalized = contentItem({
        id: item.variant_id || item.id,
        name: item.product_title || item.title,
        content_type: 'product',
        quantity: quantity,
        amount: item.final_price !== undefined ? item.final_price : item.price,
        currency: config.currency
      });
      if (normalized) normalized.key = item.key ? String(item.key) : '';
      return normalized;
    }).filter(Boolean);
  }

  function addToCartState(items) {
    items.forEach(function (item) {
      var existing = cartState.contents.find(function (candidate) {
        return (item.key && candidate.key === item.key) || (!item.key && candidate.id === item.id);
      });
      if (existing) {
        existing.quantity += item.quantity || 1;
        existing.amount = item.amount;
        existing.currency = item.currency;
      } else {
        cartState.contents.push({
          key: item.key || '',
          id: item.id || '',
          name: item.name || '',
          content_type: item.content_type || 'product',
          quantity: item.quantity || 1,
          amount: item.amount !== undefined ? item.amount : null,
          currency: item.currency || currency(config.currency)
        });
      }
    });
    cartState.amount = null;
  }

  function sendItemsAdded(items) {
    if (!items.length) return;
    var total = items.reduce(function (sum, item) {
      return item.amount === undefined || item.amount === null
        ? sum
        : sum + item.amount * (item.quantity || 1);
    }, 0);
    var hasAmounts = items.every(function (item) {
      return item.amount !== undefined && item.amount !== null;
    });

    measure(
      'items_added',
      contentsData(items, hasAmounts ? total : null, config.currency),
      eventId('cart-add')
    );
  }

  function handleAddSuccess(response, request) {
    if (!response || response.status) return;
    var items = addedItemsFromResponse(response, request);
    addToCartState(items);
    sendItemsAdded(items);
  }

  function handleCartChangeSuccess(response) {
    if (!response || response.errors || !Array.isArray(response.items)) return;
    var nextCart = normalizeCart(response);
    var increases = [];

    nextCart.contents.forEach(function (item) {
      var previous = cartState.contents.find(function (candidate) {
        return (item.key && candidate.key === item.key) || (!item.key && candidate.id === item.id);
      });
      var previousQuantity = previous ? previous.quantity : 0;
      if (item.quantity > previousQuantity) {
        var increase = Object.assign({}, item, {quantity: item.quantity - previousQuantity});
        increases.push(increase);
      }
    });

    cartState = nextCart;
    sendItemsAdded(increases);
  }

  function instrumentCartFetch() {
    if (!nativeFetch) return;

    window.fetch = function (input, init) {
      var request = cartRequest(input, init);
      var responsePromise = nativeFetch.apply(this, arguments);

      if (request) {
        responsePromise.then(function (response) {
          if (!response || !response.ok) return;
          response.clone().json().then(function (body) {
            if (request.type === 'add') {
              handleAddSuccess(body, request);
            } else {
              handleCartChangeSuccess(body);
            }
          }).catch(function () {});
        }).catch(function () {});
      }

      return responsePromise;
    };
  }

  function checkoutData() {
    return contentsData(cartState.contents, cartState.amount, cartState.currency || config.currency);
  }

  function productCheckoutData(target) {
    if (!config.product) return checkoutData();

    var product = Object.assign({}, config.product);
    var form = target && target.closest ? target.closest('form') : null;
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var quantityInput = form ? form.querySelector('[name="quantity"]') : null;
    var selectedId = idInput && idInput.value ? String(idInput.value) : String(product.id || '');
    var quantity = integer(quantityInput && quantityInput.value, 1);

    if (selectedId && selectedId !== String(product.id || '')) {
      product.id = selectedId;
      delete product.amount;
    }
    product.quantity = quantity;

    var total = product.amount !== undefined ? integer(product.amount, 0) * quantity : null;
    return contentsData([product], total, product.currency || config.currency);
  }

  function sendCheckoutStarted(data) {
    if (checkoutMeasured) return;
    checkoutMeasured = true;
    measure('checkout_started', data || checkoutData(), eventId('checkout'));
  }

  function isLeadForm(form) {
    return Boolean(form && form.matches(
      '.kz-contact__form, .kz-pb__form, .section-contact-form form'
    ));
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (isLeadForm(form) && !event.defaultPrevented) {
      pendingLead = {
        id: eventId('lead'),
        path: window.location.pathname,
        expiresAt: Date.now() + 60 * 60 * 1000
      };
      safeSessionSet('openai_ads_pending_lead', JSON.stringify(pendingLead));
    }

    if (!form || !form.matches('[data-cart-form]') || event.defaultPrevented) return;
    var submitter = event.submitter;
    if (!submitter || submitter.name === 'checkout' || submitter.matches('.cart__checkout')) {
      sendCheckoutStarted();
    }
  });

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest
      ? event.target.closest(
        '.shopify-payment-button__button, [data-additional-checkout-button] button, [data-additional-checkout-button] a, a[href*="/checkout"]'
      )
      : null;
    if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
    sendCheckoutStarted(
      target.matches('.shopify-payment-button__button') ? productCheckoutData(target) : checkoutData()
    );
  });

  instrumentCartFetch();
  initializeConsent();
})(window, document);
